/* eslint-disable no-unused-vars */
import axios from "axios";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/login`;

const state = {
  token: localStorage.getItem("access_token") || null,
  position: localStorage.getItem("user_position") || null,
  bypass_key: localStorage.getItem("bypass_key") || null,
  office: localStorage.getItem("user_office") || null,
  error: "",
  user_name: localStorage.getItem("user_name") || null,
  user_id: localStorage.getItem("val") || null
};

const getters = {
  loggedIn() {
    return state.token;
  },
  loggedInPosition: (state) => state.position,
  loggedInOffice: (state) => state.office,
  loggedInUserID: (state) => state.user_id,
  bypassKey: (state) => state.bypass_key,
  errors: (state) => state.error,
  loggedInUserName: (state) => state.user_name,
};

const actions = {
  retrieveToken({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, credentials)
        .then((response) => {
          let { token, bypassKey } = response.data;

          let base64Url = token.split(".")[1]; // token you get
          let base64 = base64Url.replace("-", "+").replace("_", "/");
          let decodedData = JSON.parse(
            Buffer.from(base64, "base64").toString("binary")
          );
          let { position, name, office, _id } = decodedData;
          console.log(decodedData)
          localStorage.setItem("access_token", token);
          localStorage.setItem("user_position", position);
          localStorage.setItem("user_office", office);
          localStorage.setItem("bypass_key", bypassKey);
          localStorage.setItem("user_name", name);
          localStorage.setItem("val", _id);

          commit("setToken", { token, position, bypassKey, name, office, _id });
          resolve(response.data);
        })
        .catch((err) => {
          reject(commit("errorHandler", err.response.data));
        });
    });
  },
  destroyToken({ commit }) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_position");
    localStorage.removeItem("bypass_key");
    localStorage.removeItem("user_name");
    localStorage.removeItem("office");
    localStorage.removeItem("val");
    commit("setToken", { token: null, position: null, user_name: null, office: null, _id: null });
    return true;
  },
};

const mutations = {
  setToken: (state, body) => {
    const { token, position, bypassKey, name, office, _id } = body;
    state.token = token;
    state.position = position;
    state.bypass_key = bypassKey;
    state.user_name = name;
    state.office = office;
    state.user_id = _id
  },
  errorHandler: (state, error) => {
    state.error = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
